import { useUnit } from 'effector-react'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { $creatorId } from '@/models/creators.ts'
import { rebillMessageService } from '@/modules/creator-settings/rebill-messages/service/rebill-message.ts'
import { useSettingsContext } from '@/modules/creator-settings/state/SettingsProvider.tsx'
import { handleError } from '@/utils/error'

export function useDeleteRebillMessageMutation() {
  const toast = useToast()
  const client = useQueryClient()
  const creatorId = useUnit($creatorId)
  const { settingsSortOptions } = useSettingsContext()

  return useMutation(
    (messageId: string) => {
      if (!creatorId) {
        throw new Error('Creator not selected')
      }

      return rebillMessageService.delete(creatorId, messageId)
    },
    {
      onSuccess: () => {
        toast.success('The message was removed')
        client.invalidateQueries(['settings', creatorId, settingsSortOptions])
      },
      onError: (error) => {
        handleError(error, 'Failed to remove the message')
        client.invalidateQueries(['settings', creatorId, settingsSortOptions])
      },
    },
  )
}
